export const getRetailerInformation = (orderOptions) => {
    const contactInformation = orderOptions
        ? orderOptions.getContactInformation()
        : null;
    if (contactInformation) {
        return {
            name: contactInformation.name || "",
            email: contactInformation.email || "",
            phoneNumber: contactInformation.phone || "",
        };
    }
    return {
        name: "",
        email: "",
        phoneNumber: "",
    };
};
